let canonicalAsciiByKeyGetter: (() => Record<string, string>) | undefined;

/** Wired from shared/instance after buildUnitRegistry. */
export function setCanonicalAsciiByKeyGetter(getter: () => Record<string, string>): void {
  canonicalAsciiByKeyGetter = getter;
}

export function getCanonicalAsciiByKey(): Record<string, string> {
  return canonicalAsciiByKeyGetter?.() ?? Object.create(null);
}
